import { Divider, Tooltip } from "antd"
import classNames from "classnames/bind"

import { IMAGE_BASE_URL } from "../../../../api/config"
import { CustomModal } from "../../../../assets/css/styled"
import { CloseIconSm, DiagramRedTeamIcon } from "../../../../assets/svg"
import { Label } from "../../../../components"

import {
  DiagramTooltipRedTeam,
  DiagramTooltipRedTeamProps
} from "./DiagramTooltip"
import styles from "./styles.module.scss"

const cx = classNames.bind(styles)
const KALI_LINUX: DiagramTooltipRedTeamProps = {
  name: "Kali Linux",
  ip: "10.112.0.10",
  user: "cyberlab",
  password: "99Password99",
  sshAccess: "",
  rdpAccess: "",
  description:
    "To connect to your virtual machine via Remote Desktop, download the RDP file below."
}
function DiagramRedTeam({
  imageBig,
  legend,
  handleOpenModalLegend,
  handleCancelModalLegend,
  isModalLegendOpen,
  handleLaunchVNC,
  downloadSpiceFile
}: {
  imageBig: any
  legend: []
  handleOpenModalLegend: any
  handleCancelModalLegend: any
  isModalLegendOpen: any
  handleLaunchVNC: any
  downloadSpiceFile: any
}) {
  return (
    <div className={cx("overlay")}>
      <img
        style={{
          objectFit: "contain",
          width: "100%",
          height: "257px",
          marginLeft: "8px",
          padding: "0px"
        }}
        src={`${IMAGE_BASE_URL}${imageBig}`}
        alt=""
      />
      <CustomModal
        title="Connectivity Details"
        centered
        closeIcon={<CloseIconSm />}
        open={isModalLegendOpen}
        onCancel={handleCancelModalLegend}
        footer={null}
        maskClosable={false}
      >
        <div>
          {legend?.length > 0 ? (
            legend?.map((legendsImage: any) => (
              <>
                <div style={{ display: "flex" }}>
                  <img
                    src={`${IMAGE_BASE_URL}${legendsImage?.Image?.data?.attributes?.url}`}
                    alt=""
                    className={cx("kali-linux")}
                  />

                  <div>
                    <p
                      className={cx("text")}
                      dangerouslySetInnerHTML={{
                        __html: legendsImage?.Description
                      }}
                    />
                    {legendsImage?.UploadFile?.data?.attributes?.url ? (
                      <button type="button" className={cx("button")}>
                        <a
                          href={`${IMAGE_BASE_URL}${legendsImage?.UploadFile?.data?.attributes?.url}`}
                          download={`${IMAGE_BASE_URL}${legendsImage?.UploadFile?.data?.attributes?.url}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download RDP File
                        </a>
                      </button>
                    ) : null}
                  </div>
                </div>
                {legend?.length > 1 ? (
                  <Divider className={cx("dividerline")} />
                ) : null}
              </>
            ))
          ) : (
            <div className={cx("my-20")}>
              <p>No legends are added</p>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              margin: 20
            }}
          >
            <p>
              <Label
                onClick={downloadSpiceFile}
                name="Download SPICE file"
                color="#D5550D"
              />
            </p>
            <p>
              <Label
                onClick={handleLaunchVNC}
                name="Launch VNC"
                color="#D5550D"
              />
            </p>
          </div>
        </div>
      </CustomModal>
    </div>
  )
}

export default DiagramRedTeam
